import React, { useRef, useState, useEffect } from 'react'
import { Accordion, AccordionTab } from "primereact/accordion";
import { Api } from '../../../services/api';
import { useFormik } from 'formik';
import { useNavigate } from "react-router-dom";
import { Button } from 'primereact/button';
import { EstimatorTemplate } from '../../../services/Template/estimator-template';
import { Toast } from 'primereact/toast';
import { InputNumber } from 'primereact/inputnumber';
import './WARRANTY.css';
import { FaCopy, FaPlus, FaTrash, FaSave } from 'react-icons/fa';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputText } from 'primereact/inputtext';
import { TriStateCheckbox } from 'primereact/tristatecheckbox';
import { Checkbox } from 'primereact/checkbox';
import "../../Lidtracker/Leads/Leads.css";
import "../../Dasbord.css";


const WARRANTY = ({ pmId }) => {
    const [isLoading, setIsLoading] = useState(true);
    const elementRefs = useRef([]);


    const [Title, setTitle] = useState([1, 2, 3, 4, 5,6]);
    const toast = useRef(null);

    const formik = useFormik({
        initialValues: EstimatorTemplate.getFormWarranty(),
        validate: (data) => {

        },

        onSubmit: (data) => {
            if(!existPageWithoutSave){
                return;

            }

            const token = localStorage.getItem('authToken');

            // Create headers with token if it exists
            const headers = {
               'Content-Type': 'application/json',
                'Authorization': token ? `Bearer ${token}` : ''
            };
            data.user_id = localStorage.getItem('user_id');
            data.role_id = localStorage.getItem('role_id');

            var url = Api.API_BASE_URL + 'warrenty/save';


            fetch(url, {
                method: "POST",
                headers: headers,
                body: JSON.stringify(data),
            })
                .then((response) => response.json())
                .then((Josn) => {
                    setExistPageWithoutSave(false);
                    if (Josn.error != '') {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: Josn.error });

                    } else {
                        toast.current.show({ severity: 'success', summary: 'Success', detail: Josn.result });
                    }
                })
                .catch((error) => {
                    console.error("Error:", error);
                });


        }
    });

    const handleAddInputForTitle = () => {
        setTitle([...Title, 1]);

        // warranty
        formik.values.warranty.push({
            followup: '',
            reminder: '',
            followUpDate: '',
            warranty: '',
            tradePartner: '',
            whoPays: '',
            issue: '',
        });
    };

    const handleDeleteInputForTitle = (index) => {

        formik.values.warranty.splice(index, 1);
        setTitle([...Title, 2]);
        var newArray = [...Title];
        newArray.splice(index, 1);
        setTitle(newArray);
    };

    const adjustTextareaHeight = (textarea) => {
        textarea.style.height = 'auto'; // Reset the height
        textarea.style.height = textarea.scrollHeight + 'px'; // Set the height to the scroll height
    };
    
    // ----------------------------------------------------------------------------
    const [existPageWithoutSave, setExistPageWithoutSave] = useState(false);

    useEffect(() => {
        // setIsLoading(false);
      //  getProjectDetails();

        if (pmId != 0) {

            formik.setFieldValue('projectId', pmId)
            getProjectDetails(pmId)
        }


        return () => {
            // Cleanup tasks before the component is unmounted
            // if (existPageWithoutSave) {
            // if (window.confirm('Do you want to save changes you made to this document?')) {
            formik.handleSubmit();
            // }
            //   }
        };
    }, [pmId,]);


    const getProjectDetails = async (id) => {
        // fetch.
        const token = localStorage.getItem('authToken');

        // Create headers with token if it exists
        const headers = {
           'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
        };
        fetch(Api.API_BASE_URL + 'warrenty/get/' + id, {
            method: "GET",
            headers:headers

        })
            .then((response) => response.json())
            .then((response) => {



                    if (response.error == '') {

                        console.log(response.result)
                        formik.setFieldValue(`warranty`, response.result);
    
    
                        formik.setFieldValue(`warranty`, response.result);
                        formik.setFieldValue(`VPComments`, response.result[0].VPComments);
                        formik.setFieldValue(`projectComplationDate`, response.projectComplationDate);
                        // console.log(response.projectComplationDate);
                        var t = response.projectComplationDate;
                        console.log(t);
                        if (response.result.length == 0) {
    
                        }
    
                        var arr = [];
                        response.result.map((e) => {
                            arr.push(1);
                        });
                        setTitle(arr);
    
                        formik.setFieldValue(`warranty.0.followUpDate`, handleData(response.projectComplationDate, 3));
                        formik.setFieldValue(`warranty.1.followUpDate`, handleData(response.projectComplationDate, 6));
                        formik.setFieldValue(`warranty.2.followUpDate`, handleData(response.projectComplationDate, 12));
                        formik.setFieldValue(`warranty.3.followUpDate`, handleData(response.projectComplationDate, 24));
                        
                        formik.setFieldValue(`projectComplationDate`, response.projectComplationDate);
                        formik.setFieldValue(`scheduleConstructionStartDate`, response.scheduleConstructionStartDate);
    
                    } else {
    
                        formik.setFieldValue(`warranty.0.followUpDate`, handleData(response.projectComplationDate, 3));
                        formik.setFieldValue(`warranty.1.followUpDate`, handleData(response.projectComplationDate, 6));
                        formik.setFieldValue(`warranty.2.followUpDate`, handleData(response.projectComplationDate, 12));
                        formik.setFieldValue(`warranty.3.followUpDate`, handleData(response.projectComplationDate, 24));

                        formik.setFieldValue(`projectComplationDate`, response.projectComplationDate);
                        formik.setFieldValue(`scheduleConstructionStartDate`, response.scheduleConstructionStartDate);
                    }

                setIsLoading(false);
            })
            .catch((error) => {
                // setIsLoading(false);
                console.error("Error:", error);
                setIsLoading(false);
            });
    }

    const handleData = (startDate, monthsToAdd) => {
        let givenDate = new Date(startDate);

        givenDate.setMonth(givenDate.getMonth() + monthsToAdd);

        // Format the date
        const year = givenDate.getFullYear();
        const month = String(givenDate.getMonth() + 1).padStart(2, '0'); // Adding 1 because month index starts from 0
        const day = String(givenDate.getDate()).padStart(2, '0');

        // Formatted date string
        return `${year}-${month}-${day}`;
    }






    // ----------------------------------------------------------------------------

    const headerStyle = {
        background: "#FEC025",
        border: "1px solid #E9ECEF",
        textAlign: "center",
    };

    const cellStyle = {
        border: "1px solid #E9ECEF",
        borderLeft: "2px solid #E9ECEF",
        backgroundColor: 'white',
        textAlign: 'center',
    };   
     const cellStylea = {
        border: "1px solid #E9ECEF",
        borderLeft: "2px solid #E9ECEF",
        // backgroundColor: 'white',
        textAlign: 'center',
    };

    const cellStylee = {
        border: "1px solid #E9ECEF",
        borderLeft: "2px solid #E9ECEF",
        textAlign: 'end',
    };

    const cellStyleW = {
        border: "1px solid #E9ECEF",
        borderLeft: "2px solid #E9ECEF",
        //backgroundColor: 'white',
        paddingTop: '5px'
    };



    //! ----------------------------------------------------------

    const renderTextAreaFull = (fieldName, placeholder, rowCount = 2,  formData = '',) => (
        <InputTextarea
          placeholder={placeholder}
          name={fieldName}
          autoResize
          id={fieldName}
          rows={rowCount}
          value={formData !== '' ? formData : formik.values[fieldName]}
          onChange={(e) => {
            console.log(e.target.value)
            setExistPageWithoutSave(true);
            formik.setFieldValue(fieldName, e.target.value)
          }}
          className="w-full text-center p-2 mb-0 bg-transparent border-none"
        />
      );
    

    const renderInputArea = (fieldName, placeholder, type = 'text', formData = '') => {
        if(type=='date'){
            
            if(formData != null){
                let timestamp = new Date(formData);

                

                if (!isNaN(timestamp.getTime())) {
                    formData= timestamp.toISOString().split('T')[0];
                 }
            }
        }
        return(
        <input
            type={type}
            placeholder={placeholder}
            name={fieldName}
            id={fieldName}
            value={formData != '' ? formData : formik.values[fieldName]}
            step="any"
            onChange={(e) => {
                setExistPageWithoutSave(true);
                formik.setFieldValue(fieldName, e.target.value)
                console.log(fieldName);
                if (fieldName === 'section_4.0.PlannedCompletionDate') {
                    console.log('Testing');
                    formik.setFieldValue('scheduleConstructionStartDate', e.target.value)

                }
                if (fieldName === 'section_4.12.CurrentForecastCompletionDate') {
                    formik.setFieldValue('scheduleProjectCompletion', e.target.value)
                }


            }} onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    e.preventDefault(); // Prevent form submission on Enter key press
                }
            }}
            style={{
                width: '100%',
                height: '40px',
                boxSizing: 'border-box',
                border: 'none',
                textAlign: 'center',
                marginTop: '0px',
                 backgroundColor:'transparent'
            }}
        />
    )};

    const renderCheckArea = (fieldName, placeholder, type = 'text', formData = true) => (
        <Checkbox  
            type={type}
            placeholder={placeholder}
            name={fieldName}
            id={fieldName}
         
            //value={ formData }
             value={ formData }
             checked={ formData =='Y'? true :false }
           // step="any"
            onChange={(e) => {
                setExistPageWithoutSave(true);
                formik.setFieldValue(fieldName, e.checked ? 'Y' : 'N' ); // Map boolean value back to 'Y' or 'N'
                // formik.setFieldValue(fieldName, e.value ); // Map boolean value back to 'Y' or 'N'
                console.log('New value:', e.value);
            }} 
            style={{
                textAlign: 'center',
                backgroundColor:'transparent'
            }}
        />
    );
    
    
    //! ----------------------------------------------------------------------------

const getBackgroundValue = (remainder, followupDate) => {
    const today = new Date();
    return remainder === 'N' && new Date(followupDate) < today;
};


    // ----------------------------------------------------------------------------

    return (
        <>
            <Toast ref={toast} />
            {isLoading ? (
        <div className="loading-spinner">
          Loading...
          <div className="spinner"></div>
        </div>
      ) : (

            <div className="dashboard-container" style={{ height: '100vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                <div className="dashboard-header flex align-items-center justify-content-between p-3 flex-shrink-0">
                    <h1 className="dashboard-title">Warranty Template</h1>
                    <div className="flex gap-2">
                        <Button className="customSave-button font-bold" type="button" onClick={formik.handleSubmit}>
                            <FaSave className="mr-2"/>
                            Save
                        </Button>
                    </div>
                </div>

                <div className="dashboard-card overflow-y-auto h-full p-4 flex-grow-1">
                    <form onSubmit={formik.handleSubmit}>
                        
                        <Accordion multiple activeIndex={[0, 1, 2, 3, 4, 5, 6]}>

                        <AccordionTab header="FOLLOWUP" className="mt-2">
                            <div className="table-container" style={{ overflowX: "auto" }}>
                                <table style={{ borderCollapse: "collapse", }}>
                                    <thead>

                                        <tr>
                                            <th style={{ ...headerStyle, width: "400px", }}>
                                                Followup
                                            </th>
                                            <th style={{ ...headerStyle, minWidth: "auto", }}>
                                                Follow up
                                            </th>
                                            <th style={{ ...headerStyle, minWidth: "auto", }}>
                                                Follow up Date
                                            </th>
                                            
                                            <th style={{ ...headerStyle, minWidth: "auto", }}>
                                                Warranty/Deficiency
                                            </th>
                                            <th style={{ ...headerStyle, minWidth: "auto", }}>
                                                Trade Partner
                                            </th>
                                            <th style={{ ...headerStyle, minWidth: "auto", }}>
                                                Who Pays?
                                            </th>

                                            <th style={{ ...headerStyle, minWidth: "auto", }}>
                                                Issue
                                            </th>

                                            <th style={{ ...headerStyle, width: "80px", }}>Add Remove Rows
                                            </th>

                                        </tr>

                                    </thead>

                                    <tbody>

                                        {Title.map((item, index) => (
                                            <tr style={{backgroundColor:getBackgroundValue(formik.values.warranty[index].reminder,formik.values.warranty[index].followUpDate)?"red":"white"}}>
                                                <td style={cellStyleW} >
                                                    {renderTextAreaFull(`warranty.${index}.followup`, '', 2, formik.values.warranty[index].followup)}
                                                </td>
                                                <td style={cellStylea} >
                                                    {renderCheckArea(`warranty.${index}.reminder`, '', 2, formik.values.warranty[index].reminder)}
                                                </td>
                                                <td style={cellStyleW}>
                                                    {renderInputArea(`warranty.${index}.followUpDate`, '', 'date', formik.values.warranty[index].followUpDate)}
                                                </td>
                                                <td style={cellStyleW}>
                                                    {renderInputArea(`warranty.${index}.warranty`, '', '', formik.values.warranty[index].warranty)}
                                                </td>
                                                <td style={cellStyleW}>
                                                    {renderInputArea(`warranty.${index}.tradePartner`, '', '', formik.values.warranty[index].tradePartner)}
                                                </td>
                                                <td style={cellStyleW}>
                                                    {renderInputArea(`warranty.${index}.whoPays`, '', 'text', formik.values.warranty[index].whoPays)}
                                                </td>
                                                <td style={cellStyleW}>
                                                    {renderTextAreaFull(`warranty.${index}.issue`, '', 'text', formik.values.warranty[index].issue)}
                                                </td>

                                                <td style={cellStyleW}>
                                                    {index > 3 ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputForTitle(index)} />) : null}

                                                    {Title.length - 1 == index ? (<FaPlus className='add-buttonXX' onClick={() => handleAddInputForTitle()} />) : null}
                                                </td>
                                            </tr>
                                        ))}

                                    </tbody>
                                </table>
                            </div>
                        </AccordionTab>

                        <AccordionTab header="VP CONSTRUCTION OPS COMMENTS" className="mt-2">
                            <div className="table-container" style={{ overflowX: "auto" }}>
                                <table style={{ borderCollapse: "collapse", }}>
                                    <thead>

                                        <tr>
                                            <th style={{ ...headerStyle, minWidth: "auto", }}>
                                            VP Construction Ops Comments
                                            </th>

                                        </tr>

                                    </thead>

                                    <tbody>

                                        <tr>
                                            <td style={cellStyle}>
                                                {renderTextAreaFull(`VPComments`, '', 6)}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </AccordionTab>

                        </Accordion>
                        <div style={{ height: '300px' }}></div>
                    </form>
                </div>
            </div>

            )}
        </>
    )
}

export default WARRANTY